// 회사 정보 단일 소스 — 여기만 고치면 모든 페이지에 반영됩니다.
export const company = {
  nameKo: '엔케이시스템(주)',
  nameEn: 'NK System',
  initials: 'N.K.S (Next Key System)',
  ceo: '안동진',
  founded: '2022년 3월 14일',
  foundedYear: '2022',
  city: '대전광역시 대덕구',
  address: '대전광역시 대덕구 대화로150번길 113 (대화동 425) 102호, 103호',
  addressShort: '대전광역시 대덕구 대화로150번길 113',
  phone: '042-632-0907',
  phoneLink: 'tel:0426320907',
  email: 'nks@nksystems.co.kr',
  brochure: '/NKSystem_info.pdf',
  slogan: {
    before: '고객과의 ',
    parts: ['신뢰', '를 바탕으로 끊임없는 미래를 ', '창조', '하는 ', '열정', '과 ', '도전의식', '을 지닌 우리는 '],
    brand: 'NK System',
    after: '입니다.',
  },
};

export const heroPhoto = require('@/assets/photos/hero-line.jpg');
export const aboutPhoto = require('@/assets/photos/integration.jpg');

export const mapQuery = encodeURIComponent('대전광역시 대덕구 대화로150번길 113');
export const mapLinks = {
  google: `https://www.google.com/maps?q=${mapQuery}&hl=ko&z=17&output=embed`,
  kakao: `https://map.kakao.com/link/search/${mapQuery}`,
  naver: `https://map.naver.com/v5/search/${mapQuery}`,
};

export const business = [
  {
    key: 'automation',
    title: '공정 자동화',
    summary: 'PLC 제어 설계와 LabVIEW·C++ 기반 소프트웨어로 생산 공정을 자동화합니다. 통합 시스템 제어까지 한 팀이 맡습니다.',
    tags: ['PLC', 'LabVIEW', 'C++', '통합 시스템 제어'],
    icon: 'gear',
    photo: require('@/assets/photos/automation.jpg'),
  },
  {
    key: 'measurement',
    title: '시험·계측 시스템',
    summary: 'CAM 장비 설계와 DAQ(Data Acquisition) 신호 분석으로 시험 장비를 설계·개발합니다. 연구기관 시험 환경에 맞춥니다.',
    tags: ['CAM 장비 설계', 'DAQ 신호 분석'],
    icon: 'wave',
    photo: require('@/assets/photos/measurement.jpg'),
  },
  {
    key: 'integration',
    title: '시스템 통합 · 정보통신 공사',
    summary: 'H/W와 S/W를 하나의 시스템으로 통합하고, 정보통신·소방 공사를 자격 보유 인력이 직접 수행합니다.',
    tags: ['H/W·S/W 통합', '정보통신 공사', '소방 공사'],
    icon: 'nodes',
    photo: require('@/assets/photos/integration.jpg'),
  },
];

export const capabilities = {
  hardware: ['전자 회로 설계', '특수 기구 설계', 'CAM 장비 설계', 'DAQ(Data Acquisition) 신호 분석'],
  software: ['PLC', 'C++', 'LabVIEW'],
  design: ['각종 검사 및 시험장비', '자동화 시스템', '정보통신 시스템', '화재감지 소방 시스템'],
  licenses: ['무선설비기사', '정보통신기사', '소방 안전관리', '전자기기기능사'],
};

export const partners = [
  { name: '국방과학연구소', img: require('@/assets/Kubang_logo.png') },
  { name: '국립소방연구원', img: require('@/assets/911_logo.png') },
  { name: '(주)한화', img: require('@/assets/Hanwha_logo.jpg') },
  { name: 'SK온', img: require('@/assets/SK_logo.png') },
  { name: 'KDI', img: require('@/assets/KDI_logo.png') },
  { name: '한국전자통신연구원(ETRI)', img: require('@/assets/ETRI_logo.jpg') },
  { name: '한국전기연구원(KERI)', img: require('@/assets/Electric_logo.png') },
  { name: '한국기계연구원(KIMM)', img: require('@/assets/KIMM_logo.png') },
];

// 최신순 (회사소개서 2025.04 기준)
export const history = [
  { date: '2024.10', items: ['계장제어장치 직접생산확인 증명서 획득'] },
  { date: '2024.08', items: ['ISO 9001 / 14001 / 45001 품질·환경·안전보건경영시스템 갱신'] },
  { date: '2024.05', items: ['SM벡셀 배터리 협력업체 등록'] },
  { date: '2024.04', items: ['육군탄약지원사령부 업체 등록'] },
  { date: '2023.11', items: ['ISO 14001 환경경영시스템 인증', 'ISO 45001 안전보건경영시스템 인증'] },
  { date: '2023.08', items: ['ISO 9001 품질경영시스템 인증'] },
  { date: '2023.07', items: ['기업부설연구소 인정 (한국산업기술진흥협회)'] },
  { date: '2023.06', items: ['본사 및 공장 확장 이전'] },
  { date: '2023.03', items: ['한국전기연구원 거래처 등록', '한국기계연구원 거래처 등록', '(주)한화에어로스페이스 협력업체 등록'] },
  { date: '2023.02', items: ['엔케이시스템(주) 법인 전환 및 설립'] },
  { date: '2022.11', items: ['한국전자통신연구원(ETRI) 거래처 등록'] },
  { date: '2022.10', items: ['국립소방연구원 협력업체 등록'] },
  { date: '2022.07', items: ['국방과학연구소 거래처 등록', '(주)한화솔루션 협력업체 등록'] },
  { date: '2022.06', items: ['(주)SK온 협력업체 등록', '(주)한화 구미사업장 거래처 등록'] },
  { date: '2022.03', items: ['N.K.S (Next Key System) 설립', '(주)KDI 협력업체 등록'] },
];

export const partnerCount = 12;

export const organization = {
  head: '대표이사',
  staff: { title: '품질경영팀', items: ['품질경영(ISO)', '품질보증'] },
  teams: [
    { title: '운영팀', items: ['경영지원팀', '구매관리팀'] },
    { title: '기술영업팀', items: ['방산영업', '민수영업'] },
    { title: '개발사업부', items: ['전기·전자 개발팀', '기계장비 개발팀', '소프트웨어 개발팀'] },
    { title: '기술연구소', items: ['신기술 개발', '제품 및 상품화 개발'] },
  ],
};


// 주요 제품·장비 (회사소개서 2025.04 기준)
export const productCategories = [
  { key: 'defense', label: '방산' },
  { key: 'civil', label: '민수' },
  { key: 'research', label: '연구' },
];

export const products = [
  { cat: 'defense', name: '신관 점검장비', desc: '신관의 특성 신호등을 정밀 계측하여 평가', specs: ['계측기 자동제어 (RS232 / Ethernet)', '시험 항목·채널 수량 Customizing', '제어 PC 연동 Data Measurement 및 Display', '시험결과 DB 관리'], img: require('@/assets/products/fuze-tester.jpg') },
  { cat: 'defense', name: '케이블 점검장비', desc: '미사일 케이블의 도통 저항, 절연저항을 계측 및 평가', specs: ['계측기 자동제어 (RS232 / USB)', '케이블 Pin 연결 Matrix 회로 구성', '제어 PC 연동 Data Measurement 및 Display', '성적서 출력'], img: require('@/assets/products/cable-tester.jpg') },
  { cat: 'defense', name: '정전류 기폭장치', desc: '착화기의 기폭 성능을 시험', specs: ['전원공급장치 자동제어 (RS232)', 'LCD 원격제어 (RS232)', '인가 전압/전류 설정', '설정 전압/전류로 착화기 기폭'], img: require('@/assets/products/cc-igniter.jpg') },
  { cat: 'defense', name: '회전 낙하 시험장비', desc: '특정 양산 제품의 작동 여부 시험', specs: ['회전모터 및 실린더 자동제어', 'PLC / Touch Panel 연동', '시험 환경 설정 / 시험 결과 표시'], img: require('@/assets/products/rotary-drop.jpg') },
  { cat: 'defense', name: '관성 시험기', desc: '신관 비장전/장전 시험', specs: ['회전 모터 RPM 제어', '실린더 자동제어', 'PLC / Touch Panel 연동', '회전에 따른 비장전/장전 여부 확인'], img: require('@/assets/products/inertia-tester.jpg') },
  { cat: 'defense', name: '전지 활성화 시험장비', desc: '소형전지 활성화 시험', specs: ['실린더 자동 제어', '설정압력으로 버드 발사', '버드 이동 속도 자동 계산', '전지 활성화 전압 자동 측정', '다수 데이터 통합 뷰어 제공'], img: require('@/assets/products/battery-activation.jpg') },
  { cat: 'defense', name: '점블 시험기', desc: '신관 안전성 시험', specs: ['점블통에 신관 삽입 후 회전', '회전수 확인 가능 (Pulse Indicator)', '회전수에 따른 신관 안전성 수동 평가', '크기 910 x 1,250 x 1,240 (DxWxH) mm · 약 400kg'], img: require('@/assets/products/jumble-tester.jpg') },
  { cat: 'defense', name: '방수 시험기', desc: '신관의 방수 성능 시험', specs: ['챔버에 증류수 주입 후 내부 압력 설정', '해당 조건에서의 신관 방수 성능 수동 평가', '챔버 내부 압력 가/감압 설정 가능', '크기 1,450 x 760 x 660 (DxWxH) mm · 약 200kg'], img: require('@/assets/products/waterproof-tester.jpg') },
  { cat: 'civil', name: 'Portable 모듈 점검 계측기', desc: '특정 제품의 전압, 전류, 온도를 계측 및 평가', specs: ['계측기 자동제어 (DMM)', 'DAQ 내부 탑재 (전압, 전류, 온도 계측용)', 'Rack Type으로 이동성 확보', '일체형 PC 내장', '계측 Data 실시간 Display / Save'], img: require('@/assets/products/portable-meter.jpg') },
  { cat: 'civil', name: '화재 모니터링 시스템', desc: '건물 전체 각 연구실의 화재 상태 모니터링', specs: ['각 연구실 외부 화재 수신반 설치', '각 실 화재 상태 신호를 통신으로 일괄 전송 (RS485 / 광통신 중계기)', '통합 모니터링 PC로 상태 신호 수신', 'GUI에 표시 및 화재 시 알람 발생'], img: require('@/assets/products/fire-monitoring.jpg') },
  { cat: 'research', name: '배터리팩 모형 제작', desc: '배터리팩 화재 재현 실험용', specs: ['6EA 배터리 장착 가능', '냉각수 입출력 수동 밸브 장착', '냉각수 유량 조절'], img: require('@/assets/products/battery-pack-mock.jpg') },
  { cat: 'research', name: 'Linear CCD 측정 시스템', desc: '신관 자세정보 계측', specs: ['선형 이미지 센서 모듈 사용 (Linear CCD)', '신관 비행 자세 일정각도 유지 여부 검증 (태양광과 신관 주축 각도 산출)', '실시간 Data 측정 / Graph Display'], img: require('@/assets/products/linear-ccd.jpg') },
  { cat: 'research', name: '센서 활용 생산 품질 검사 스마트 자동화 시스템', desc: '생산품 품질 검사 스마트 자동화', specs: ['PLC / Touch Panel 사용', '비전, 컬러, 광, 근접 등 다양한 센서 사용', '생산품 품질검사 및 불량제품 자동 검출'], img: require('@/assets/products/smart-inspection.jpg') },
  { cat: 'research', name: '자동화 장비', desc: '제품 조립 공정 자동화 장비', specs: ['기구 / 회로 설계', 'PLC 연동', '제품 조립 공정 수행', '품질 검사', '검사 데이터 저장 / 관리'], img: require('@/assets/products/automation-equipment.jpg') },
];

// 보유 인증서
export const certifications = [
  { name: '기업부설연구소 인정서', issuer: '한국산업기술진흥협회 · 2023.07 최초 인정', img: require('@/assets/certs/lab-cert.jpg') },
  { name: '직접생산확인증명서', issuer: '한국중소벤처기업유통원 · 계장제어장치', img: require('@/assets/certs/direct-production.jpg') },
  { name: 'ISO 9001', issuer: '품질경영시스템 · 2023.08', img: require('@/assets/certs/iso9001.jpg') },
  { name: 'ISO 14001', issuer: '환경경영시스템 · 2023.11', img: require('@/assets/certs/iso14001.jpg') },
  { name: 'ISO 45001', issuer: '안전보건경영시스템 · 2023.11', img: require('@/assets/certs/iso45001.jpg') },
];
